import React, { forwardRef } from 'react';

import { useTranslation } from 'react-i18next';

import BdsActivityPill from '../../../../../../shared/components/v3/BdsActivityPill/BdsActivityPill';
import BdsCircleIndicatorPictogram from '../../../../../../shared/components/v3/BdsCircleIndicator/BdsCircleIndicatorPictogram/BdsCircleIndicatorPictogram';
import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { CHALLENGES_ICON } from '../../../../../../shared/constants/images';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import SectionAnchor from '../SectionAnchor/SectionAnchor';

import './ChallengeData.scss';

export const ChallengeData = forwardRef(({ data }: { data: IHealthReport }, ref: React.Ref<HTMLDivElement>) => {
  const { t } = useTranslation();
  const hasTopChallenges = data.topChallenges?.length > 0;

  return (
    <div className="challenge-data-container" ref={ref}>
      <div className="cd-header-container">
        <SectionAnchor />
        <div className="health-report-section-title">
          {t(TRANSLATIONS_REPORTS.healthReport.challengeData.header.title)}
        </div>
        <div className="health-report-description">
          {t(TRANSLATIONS_REPORTS.healthReport.challengeData.header.description)}
        </div>
      </div>
      <div className={`cd-metrics-container ${!hasTopChallenges && 'empty-top-challenges'}`}>
        <div className="metric-item">
          <div className="metric-value">{data.usersChallengesPercentage + '%'}</div>
          <div className="metric-label">{t(TRANSLATIONS_REPORTS.healthReport.challengeData.metrics.challenges)}</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{data.usersDonationsPercentage + '%'}</div>
          <div className="metric-label">{t(TRANSLATIONS_REPORTS.healthReport.challengeData.metrics.donations)}</div>
        </div>
      </div>
      {hasTopChallenges && (
        <div className="cd-challenges-container">
          <div className="health-report-section-subtitle">
            {t(TRANSLATIONS_REPORTS.healthReport.challengeData.challenges.title)}
          </div>
          <div className="cd-challenge">
            {data.topChallenges.map((challenge, index) => (
              <div className="cd-challenge-item" key={challenge.challengeType}>
                <BdsCircleIndicatorPictogram
                  circleIndicatorSize="m"
                  pictogram={challenge.iconUrl ? { url: challenge.iconUrl } : { component: CHALLENGES_ICON }}
                  className="cd-icon"
                />
                <div className="cd-text-container">
                  <div className="cd-challenge-name">
                    {t(challenge.typeName ?? TRANSLATIONS_REPORTS.healthReport.challengeData.challenges.defaultType)}
                  </div>
                  <div className="cd-challenge-amount">
                    {t(TRANSLATIONS_REPORTS.healthReport.challengeData.challenges.users, {
                      users: challenge.users,
                      count: challenge.users
                    })}
                  </div>
                  <BdsActivityPill
                    variant="filled"
                    className="cd-challenge-value"
                    label={<div>{challenge.percentage + '%'}</div>}
                  />
                </div>
                <div className={`cd-rectangle color-${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      )}
      <BdsDivider size="s" color="high" />
    </div>
  );
});

ChallengeData.displayName = 'ChallengeData';
export default ChallengeData;
